import React from "react";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  label: string | React.ReactNode;
  required?: boolean;
  optional?: boolean;
  value: string | React.ReactNode;
  displayActionCell?: boolean;
  action?: React.ReactNode;
  disableDivider?: boolean;
  className?: string;
}

export function FormRow(props: Props) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Row key={`formRow-${props.label}`} className={props.className || "py-3"}>
        <Col xs={12} sm={5} key={`labelCell-${props.label}`} className={"d-flex align-items-center pl-sm-4"}>
          {React.isValidElement(props.label) ? (
            props.label
          ) : (
            <>
              <Typography key={`valueText-${props.label}`} variant="subtitle2" color="textPrimary">
                {props.label}
              </Typography>
              {props.required && (
                <Typography
                  key={`valueText-${props.label}-required`}
                  variant="caption"
                  color="textSecondary"
                  component="p"
                >
                  &nbsp; {t("common.required")}
                </Typography>
              )}
              {props.optional && (
                <Typography
                  key={`valueText-${props.label}-optional`}
                  variant="caption"
                  color="textSecondary"
                  component="p"
                >
                  &nbsp; {t("common.optional")}
                </Typography>
              )}
            </>
          )}
        </Col>
        <Col key={`valueCell-${props.label}`} className={"d-flex align-items-center"}>
          {React.isValidElement(props.value) ? (
            props.value
          ) : (
            <Typography key={`valueText-${props.label}`} variant="body2" color="textPrimary" component="p">
              {props.value}
            </Typography>
          )}
        </Col>
        {(props.displayActionCell || props.action) && (
          <Col xs={1} key={`actionCell-${props.label}`} className={"d-flex align-items-center justify-content-center "}>
            {props.action}
          </Col>
        )}
      </Row>
      {!props.disableDivider && <Divider />}
    </React.Fragment>
  );
}
